// เลือกปลายทางหลัง Login จาก Profile owner เดียวเพื่อให้ Google และ Username ใช้เงื่อนไขตรงกัน
export const getPostLoginDestination = (profile) => {
  if (!profile?.first_login) return "/";
  const email = encodeURIComponent(profile?.email || "");
  return `/firstlogin?email=${email}`;
};

/**
 * ประสานการล้าง state, โหลด Storage, restore แผน และ persist Profile ตามลำดับเดียวกันทุกช่องทาง Login
 * API failure จะถูกส่งกลับให้หน้า Login จัดการ และจะไม่ตั้ง userData จาก state ที่โหลดไม่ครบ
 */
export const createProfileSessionLoader = ({
  api,
  clearPlanState,
  getDefaultPlanState,
  normalizeStorage,
  applyStorage,
  setUserData,
}) => ({
  async load(profile) {
    if (!profile?._id) {
      const error = new Error("Authenticated Profile id is missing");
      error.code = "PROFILE_ID_MISSING";
      throw error;
    }

    clearPlanState();
    const storageResponse = await api.get(`/storages/profile/${profile._id}`);
    const defaultPlanState = getDefaultPlanState();
    const normalizedStorage = normalizeStorage(
      storageResponse?.data?.storage || {},
      defaultPlanState,
      profile
    );
    applyStorage(normalizedStorage);

    const destination = getPostLoginDestination(profile);
    if (!profile.first_login) {
      setUserData(profile);
    }

    return { destination };
  },
});
